<div class="flex h-full flex-col gap-4">
  <section class="border border-neutral-20 px-4 py-4">
    <label for="outlook-task-sync-toggle" class="flex items-center gap-3">
      <span
        class="inline-flex"
        kendoTooltip
        position="top"
        [title]="'outlookSync.task.syncDirectionTooltip' | translate"
      >
        <kendo-switch
          id="outlook-task-sync-toggle"
          [formControl]="form().controls.tasksSyncEnabled"
        ></kendo-switch>
      </span>
      <span class="font-semibold text-component-text">
        {{ 'outlookSync.task.syncTitle' | translate }}
      </span>
    </label>

    <p class="mt-2 text-sm text-component-text">
      <strong>{{ 'outlookSync.syncDirection.label' | translate }}</strong>
      {{ 'outlookSync.task.syncDirection' | translate }}
    </p>

    <label for="outlook-task-list" class="mt-3 flex flex-col gap-1.5">
      <span class="text-sm font-semibold text-component-text">
        {{ 'outlookSync.task.taskListLabel' | translate }}
      </span>
      <kendo-dropdownlist
        id="outlook-task-list"
        class="w-56"
        [data]="taskListOptions()"
        textField="label"
        valueField="value"
        [valuePrimitive]="true"
        [formControl]="taskListControl"
      ></kendo-dropdownlist>
    </label>

    <p class="mt-3 flex items-center gap-2 text-sm text-neutral-70">
      <span class="fa-icons icon-10 icon-circle-info" aria-hidden="true"></span>
      {{ 'outlookSync.task.note' | translate: { daysAfter: syncFrequency.daysAfter, minutes: syncFrequency.intervalMinutes } }}
    </p>
  </section>

  <maximizer-history-grid
    [history]="history()"
    [loading]="historyLoading()"
    [boxed]="false"
    (refresh)="refreshHistory()"
  ></maximizer-history-grid>
</div>
